import {Link} from "react-router-dom";
import React, {useState} from "react";
import {useEffect} from "react";
import {useRef} from "react";
import {useTranslation} from "react-i18next";

import {ChangeLanguage} from "../ChangeLanguage/ChangeLanguage";
import {ContactModal} from "../ContactModal/ContactModal";

const NavBar = () => {
  const pathname = window.location.pathname;
  const [openContactModal, setOpenContactModal] = useState(false);

  const {t} = useTranslation();

  const contactRef = useRef<HTMLLIElement>(null);
  const homeRef = useRef<HTMLLIElement>(null);
  const projectsRef = useRef<HTMLLIElement>(null);
  const resumeRef = useRef<HTMLLIElement>(null);
  const languageEnRef = useRef<HTMLLIElement>(null);
  const languageEsRef = useRef<HTMLLIElement>(null);

  const handleOpenModal = () => {
    setOpenContactModal(true);
  };

  const handleOpacity = (): void => {
    setTimeout((): void => {
      if (homeRef.current) {
        homeRef.current.className = `relative ml-8 max-sm:ml-0 opacity-100 duration-[1.4s] ease-in-out`;
      }
      if (projectsRef.current) {
        projectsRef.current.className = `relative ml-8 max-sm:ml-0 opacity-100 duration-[1.1s] ease-in-out`;
      }
      if (contactRef.current) {
        contactRef.current.className = `relative ml-8 max-sm:ml-0 opacity-100 duration-[0.8s] ease-in-out`;
      }
      if (resumeRef.current) {
        resumeRef.current.className = `relative ml-8 max-sm:ml-0 opacity-100 duration-[0.5s] ease-in-out`;
      }
      if (languageEnRef.current) {
        languageEnRef.current.className = `relative ml-8 max-sm:ml-0 opacity-100 duration-[0.1s] ease-in-out`;
      }
      if (languageEsRef.current) {
        languageEsRef.current.className = `relative ml-8 max-sm:ml-0 opacity-100 duration-[0.1s] ease-in-out`;
      }
    }, 1000);
  };

  useEffect((): void => {
    handleOpacity();
  }, []);

  return pathname === "/resume" ? null : (
    <nav className=" p-0 fixed  flex w-full items-center h-[70px] top-0 z-10  ">
      <ul className=" m-0 p-0 flex justify-end max-sm:hidden   max-sm:w-full max-sm:justify-evenly  max-sm:pt-0 w-11/12 list-none">
        <li ref={homeRef} className="relative opacity-0 -translate-y-8">
          <Link
            className=" text-neutral-300 flex items-center justify-between p-0 text-xl max-sm:text-base font-normal duration-300 
          before:absolute before:w-0 before:h-line-title before:-bottom-1 before:left-0 
          before:bg-blue-400 before:transition-animationLineBefore 
          hover:before:visible hover:before:w-6 hover:text-neutral-50"
            to={"/"}
          >
            {t("navbar.home")}
          </Link>
        </li>
        <li ref={projectsRef} className="relative opacity-0 -translate-y-8">
          <Link
            className="text-neutral-300 flex items-center justify-between p-0 text-xl max-sm:text-base font-normal duration-300 
          before:absolute before:w-0 before:h-line-title before:-bottom-1 before:left-0 
          before:bg-blue-400 before:transition-animationLineBefore 
          hover:before:visible hover:before:w-6 hover:text-neutral-50"
            to={"/projects"}
          >
            {t("navbar.projects")}
          </Link>
        </li>

        <li ref={contactRef} className="relative opacity-0 -translate-y-8">
          <button
            onClick={handleOpenModal}
            className="text-neutral-300 max-sm:text-black  flex items-center justify-between p-0 text-xl max-sm:text-base font-normal duration-300 
          before:absolute before:w-0 before:h-line-title before:-bottom-1 before:left-0 
          before:bg-blue-400 min-sm:before:transition-animationLineBefore 
          hover:before:visible hover:before:w-6 hover:text-neutral-50"
          >
            {t("navbar.contact")}
          </button>
          <ContactModal
            openModal={openContactModal}
            onChangeModal={setOpenContactModal}
          />
        </li>
        <li ref={resumeRef} className="relative opacity-0 -translate-y-8">
          <Link
            className="text-neutral-300 flex items-center justify-between p-0 text-xl max-sm:text-base font-normal duration-300 
          before:absolute before:w-0 before:h-line-title before:-bottom-1 before:left-0 
          before:bg-blue-400 before:transition-animationLineBefore 
          hover:before:visible hover:before:w-6 hover:text-neutral-50"
            target="_blank"
            to={"/resume"}
          >
            {t("navbar.resume")}
          </Link>
        </li>

        <li
          ref={languageEnRef}
          style={{
            display: "flex",
            gap: "3px",
            borderRadius: "5px",
          }}
          className="items-center  relative opacity-0 -translate-y-8"
        >
          <ChangeLanguage
            language="en"
            classname="text-neutral-300 flex items-center justify-between p-0 text-xl max-sm:text-base font-normal
              before:absolute before:w-0 before:h-line-title before:-bottom-1 before:left-0 
              before:bg-blue-400 before:transition-animationLineBefore 
              hover:before:visible hover:before:w-6 hover:text-neutral-50 relative max-sm:ml-0 opacity-100 duration-[0.5s] ease-in-out"
          />
          <p style={{marginTop: "2px"}}>|</p>
          <ChangeLanguage
            language="es"
            classname="text-neutral-300 flex items-center justify-between p-0 text-xl max-sm:text-base font-normal
              before:absolute before:w-0 before:h-line-title before:-bottom-1 before:left-0 
              before:bg-blue-400 before:transition-animationLineBefore 
              hover:before:visible hover:before:w-6 hover:text-neutral-50 relative max-sm:ml-0 opacity-100 duration-[0.2s] ease-in-out"
          />
        </li>
      </ul>
    </nav>
  );
};

export default NavBar;
